<template>
  <div class="kpi-owner-query-page">
    <van-search
      type="tel"
      maxlength="11"
      v-model="keyword"
      placeholder="请输入业主手机号"
      show-action
      @search="getOwner"
      @input="keyword=keyword.replace(/\s+/g, '')"
    >
      <div slot="action" @click="getOwner">
        <van-button type="info" size="small">确定</van-button>
      </div>
    </van-search>

    <div v-if="finished && !user.name" class="empty-data">
      <span>查无此人</span>
    </div>

    <div v-if="user.name">
      <div class="tip">业主信息</div>

      <div class="user-info">
        <img :src="user.avatar" alt />
        <span>
          <span class="name">{{user.name}}</span>
          <span class="mobile">{{user.mobile}}</span>
        </span>
      </div>

      <div class="tip">数据信息</div>

      <div class="data-info van-cell">
        <span class="point">
          <span class="data-info-title">浏览</span>
        </span>
        <span class="data-info-value">
          <span class="people">链接人</span>
          <span>{{user.viewUser ? user.viewUser : '--'}}</span>
        </span>
      </div>
      <div class="data-info van-cell">
        <span class="point">
          <span class="data-info-title">报名</span>
        </span>
        <span class="data-info-value">
          <span class="people">链接人</span>
          <span>{{user.enrollmentUser ? user.enrollmentUser : '--'}}</span>
        </span>
      </div>
      <div class="data-info van-cell">
        <span class="point">
          <span class="data-info-title">售卡</span>
        </span>
        <span class="data-info-value">
          <span class="people">链接人</span>
          <span>{{user.cardUser ? user.cardUser : '--'}}</span>
        </span>
      </div>
      <div class="data-info van-cell">
        <span class="point">
          <span class="data-info-title">签单</span>
        </span>
        <span class="data-info-value">
          <span class="people">归属人</span>
          <span>{{user.orderUser ? user.orderUser : '--'}}</span>
        </span>
      </div>

      <div class="tip">订单</div>

      <!--<van-list v-model="loading" :finished="finished" class="order" @load="onOrders">-->
      <!-- 空数据 -->
      <div v-if="orders.length === 0" class="empty-data">
        <span>暂无更多相关订单</span>
      </div>

      <!-- 订单列表 -->
      <div class="order" v-for="(order, key) in orders" :key="key">
        <div class="time bottom-line">
          <div v-if="order.finishTime">核销时间：{{order.finishTime}}</div>
          <div v-else>
            核销时间：
            <span class="done">待核销</span>
          </div>
          <!-- <div :class="getProgress(order).className">{{getProgress(order).text}}</div> -->
        </div>
        <!--<van-cell is-link class="bottom-line" :to="{ name: 'kpi.owner.order.show', params: { tradeNo : order.trade_no }, query: { activity_id: activity.id, progress: 1 }}">-->
        <van-cell class="bottom-line">
          <div slot="title" class="detail">
            <img
              :src="order.cover?order.cover:'https://j.weizan.cn/youxiang/images/avatar_default.jpg'"
              alt
            />
            <div class="info">
              <div class="name">{{order.name}}</div>
              <div class="price">
                &yen;
                <span class="sale">{{order.seckillPrice}}</span>
                <!--<span class="done">原价{{order.market_price}}元/{{order.unit}}</span>-->
                <span class="done" v-if="order.salePrice">原价{{order.salePrice}}元</span>
                <span class="num">x{{ order.num ? order.num : 1 }}</span>
              </div>
            </div>
          </div>
        </van-cell>
      </div>
      <!--</van-list>-->

      <!--<div class="tip">直播订单</div>-->

      <!--<van-list v-model="loading" :finished="finished" class="live-order" @load="onLiveOrders">-->
      <!--&lt;!&ndash; 空数据 &ndash;&gt;-->
      <!--<div v-if="finished && liveOrders.length === 0" class="empty-data">-->
      <!--<span>暂无相关直播订单</span>-->
      <!--</div>-->

      <!--&lt;!&ndash; 直播订单列表 &ndash;&gt;-->
      <!--<div class="order" v-for="(order, key) in liveOrders" :key="key">-->
      <!--<div class="time bottom-line">-->
      <!--<div>下单时间：{{order.cancel_at}}</div>-->
      <!--</div>-->
      <!--<van-cell is-link class="bottom-line" :to="{ name: 'kpi.owner.order.show', params: { tradeNo : order.trade_no }, query: { activity_id: activity.id, progress: 1 }}">-->
      <!--<div slot="title" class="detail"	>-->
      <!--<img :src="order.cover" alt="" />-->
      <!--<div class="info">-->
      <!--<div class="name">{{ order.name }}</div>-->
      <!--<div class="price">-->
      <!--&yen;<span class="sale">{{ order.sale_price|priceFormat }}</span>-->
      <!--<span class="done">原价{{order.market_price}}元/{{order.unit}}</span>-->
      <!--<span class="num">x{{ order.num }}</span>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</van-cell>-->
      <!--</div>-->
      <!--</van-list>-->
    </div>

    <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home', query: { user_id: user_id, kpi_uid: kpi_userid,act_id: activity_id}}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png"/>
        首页
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      activity: {},
      // user_id: 0,
      kpi_uid: 0,
      share_uid: 0,
      keyword: "",
      pageOrder: 1,
      pageLiveOrder: 1,
      loading: false,
      finished: false,
      user: {}, // 查询用户
      live_user: null,
      kpi_user: null,
      orders: [],
      liveOrders: [],
    };
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    async getOwner() {
      var phone = this.keyword;
      let res = await this.$http.post(
        `/v1/taskmanage/query_owner_info?mobile=${phone}`
      );
      console.log(res);
      if (res.data && res.code == 0) {
        this.user = res.data;
        this.orders = this.user.orderItems;
      }
    },
    onSearch() {
      this.loading = false;
      this.finished = false;
      this.page = 1;
      this.user = {};
      this.orders = [];
      this.liveOrders = [];
      this.getUser();
    },
    getUser() {
      const json = {
        activity_id: this.activity.id,
        mobile: this.keyword,
      };
      this.$fn.showLoading();
      this.$fn.get("kpi/owner", json, (res) => {
        this.$fn.closeLoading();
        if (res.status === "error") {
          return this.$fn.fail(res.msg);
        }
        this.user = res.data;
        this.orders = this.user.seckills;
        this.finished = true;
      });
    },
    onLiveOrders() {
      const json = {
        keyword: this.keyword,
        page: this.pageLiveOrder,
      };
      console.log("直播订单json", json);
      this.loading = true;
      // this.$fn.get('liveOrders', json, res => {
      //   if (res.status === 'error') {
      //     return this.$fn.fail(res.msg);
      //   }
      //   this.loading = false;
      //   this.liveOrders = this.liveOrders.concat(res.data);
      //   if (res.data.length > 0) {
      //     this.pageLiveOrder++;
      //   }
      //   if (res.meta.current_page === res.meta.last_page) {
      //     this.finished = true;
      //   }
      // });
      this.liveOrders = [
        {
          cover: "/static/images/product_img.jpg",
          name: "美国金可儿床垫金可儿乳胶枕",
          unit: "只",
          sale_price: "199.00",
          trade_no: "20190927897897897",
          market_price: "299.00",
          num: 1,
          cancel_at: "2019-09-22 17:22:00",
        },
        {
          cover: "/static/images/product_img.jpg",
          name: "美国金可儿床垫金可儿乳胶枕",
          unit: "只",
          sale_price: "199.00",
          trade_no: "20190927234875389",
          market_price: "299.00",
          num: 1,
          cancel_at: "2019-09-22 17:22:00",
        },
      ];
      // this.liveOrders = [];
      this.loading = false;
      this.finished = true;
    },
    getProgress(order) {
      const result = {};
      switch (order.progress) {
        case 0:
          result.text = "待核销";
          result.className = "do";
          break;
        case 1:
          result.text = "已核销";
          result.className = "blue";
          break;
      }
      return result;
    },
  },
};
</script>

<style lang="less">
.kpi-owner-query-page {
  .van-search {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .van-button--small {
    padding: 0;
    min-width: 50px;
  }
  .van-search__action {
    padding: 0;
    margin: 0 10px;
  }

  .tip {
    padding: 10px 15px;
  }

  .user-info {
    /*业主信息*/
    background-color: #ffffff;
    padding: 10px 15px;
    display: flex;
    flex: 1;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 50px;
      min-width: 50px;
      max-width: 50px;
      height: 50px;
      border-radius: 50%;
    }
    .name {
      font-weight: bold;
      margin: 0 10px;
    }
    .mobile {
      color: #999999;
    }
  }

  .data-info {
    /*数据信息*/
    .data-info-title {
      margin-left: 10px;
    }
    .point {
      width: 50%;
      display: flex;
      align-items: center;
    }
    .point:before {
      content: "";
      position: absolute;
      width: 7px;
      height: 7px;
      background-color: #5293fd;
      border-radius: 50%;
    }
    .data-info-value {
      width: 50%;
      text-align: left;
      .people {
        color: #999999;
        margin-right: 10px;
      }
    }
  }

  .order,
  .live-order {
    /*订单记录*/
    .empty-data {
      margin: 0 20px;
    }
  }
  .order {
    .time {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 15px;
      font-size: 12px;
      background-color: #ffffff;
      color: #999999;
    }
    .van-cell {
      align-items: center;
      width: 100%;
      line-height: 18px;
      .van-cell__title,
      .van-cell__value {
        width: 90%;
      }
      .detail {
        display: flex;
        height: 60px;
        width: 100%;
        img {
          width: 28%;
          max-width: 28%;
          min-width: 28%;
          height: 60px;
          border-radius: 4px;
          margin-right: 5px;
        }
        .info {
          height: 60px;
          position: relative;
          width: 72%;
          .name {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .price {
            font-size: 12px;
            position: absolute;
            bottom: 0px;
            line-height: 15px;
            .sale {
              color: #eb5211;
              font-size: 16px;
            }
            .num {
              font-size: 16px;
              margin-left: 5px;
            }
          }
          .done {
            text-decoration: line-through;
          }
        }
      }
    }
  }
}
</style>
